import React, { Component, Suspense } from "react";
import { replacestate } from "./../../../redux_store/actions/index";
import store from "./../../../redux_store/store/index";
import { withTranslation } from "react-multi-lang";
import "rc-tabs/assets/index.css";
import { AtTabs } from "./../../../controls/custom-tabs.styles";
import Tabs, { TabPane } from "rc-tabs";
import { NavLink, Redirect } from "react-router-dom";
import {
  defalutreduxState,
  isMultitenant,
} from "./../../../custom_functions/Constance.jsx";
import $ from "jquery";
import "bootstrap";
import { withAlert } from "react-alert";
import {
  ControlRights, getModuleRihtsOnOrderModule, Servicecallforuserrightscallback, SubMenuRightsonScreenViews, updateActiveUserTime,
  // ModuleRights,
} from "../../../custom_functions/Functions";

const createHistory = React.lazy(() => import("./../../general/History.jsx"));
const Menu = React.lazy(() => import("./../../Menu.jsx"));
const SheetSettings = React.lazy(() => import("./../../SheetSettings.jsx"));
const ApplicationHeader = React.lazy(() =>
  import("./../../general/ApplicationHeader.jsx")
);
const ApplicationFooter = React.lazy(() =>
  import("./../../general/ApplicationFooter.jsx")
);

class PProtocols extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    let notificationorder = "";
    let isnotificationprocess = false;
    if (
      props.location !== undefined &&
      props.location !== null &&
      props.location.state !== undefined &&
      props.location.state !== null
    ) {
      let notifiystate = props.location.state;

      notificationorder =
        notifiystate.ordercode !== undefined ? notifiystate.ordercode : "";
      isnotificationprocess = notifiystate.isprocess
        ? notifiystate.isprocess
        : false;
    }

    this.state = {
      validurl: true,
      MenuGroup: "SheetCreation",
      ChildMenu: "SheetViewcss",
      PageName: this.props.t("Templates.Templatemapping.IDS_LBL_TEMPLATEMAPPING", { param: "" }),
      menuoption: 0,
      open: false,
      Menuselected: "",
      modalopen: false,
      ordercode: undefined,
      userrightdetails: undefined,
      notificationorderno: notificationorder,
      isnotificationprocess: isnotificationprocess,
      sheetcreationvisible: false,
      Sheetmapvisible: false,
      screenname: "SheetMapping"
    };

    this.MainMeunClick = this.MainMeunClick.bind(this);
    this.ELNurl = window.appUrl.ELN;
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  updateuserrights(screenrights) {
    if (!store.getState().Menu?.Controlrights?.rights) {
      Servicecallforuserrightscallback("" + this.ELNurl + "/User/GetUserRightsonUser",
        {
          usercode: sessionStorage.User,
          lsusergroup: { usergroupcode: sessionStorage.multiusergroups },
        },
        () => this.setScreenView(screenrights)
      );
    } else {
      this.setScreenView(screenrights);
    }
  }

  setScreenView() {
    this.setState({
      validurl: SubMenuRightsonScreenViews("IDS_MDL_TEMPLATES", "IDS_SCN_TEMPLATEMAPPING")
    })
  }

  componentDidMount() {
    updateActiveUserTime();

    this.updateuserrights();

    if (
      this.props.location.hash !== undefined &&
      this.props.location.hash.length > 0
    ) {
      let Sheetrun = this.props.location.hash.substring(
        2,
        this.props.location.hash.length - 1
      );
      if (
        Sheetrun !== undefined &&
        Sheetrun.split(":").length > 1 &&
        Sheetrun.split(":")[0] === "orderid"
      ) {
        let ordercode = Sheetrun.split(":")[1];
        this.setState({
          MenuGroup: "SheetView",
          PageName: this.props.t("menu.IDS_REGORDEREXE", {
            param: "",
          }),
          Menuselected: "SheetView_menu_group",
          ordercode: ordercode,
        });
      }
    }

    this.setState({ activekey: 1 });
  }

  //add
  ontabclick = (key) => { };

  MainMeunClick(Menu) {
    let PageName = "";
    let open = false;
    if (Menu === "SheetCreation") {
      PageName = this.props.t("SheetView.IDS_TEMPLATEMANAGEMENT", {
        param: "",
      });
      open = false;
    } else if (Menu === "SheetView") {
      PageName = this.props.t("menu.IDS_REGORDEREXE", {
        param: "",
      });
      open = false;
    } else if (Menu === "SheetSetting") {
      PageName = this.props.t("menu.IDS_SHEETSETTING", {
        param: "",
      });
    } else if (Menu === "AuditTrail") {
      PageName = this.props.t("AuditTrail.ID_AUDITTRAIL", {
        param: "",
      });
      open = false;
    } else if (Menu === "UserManagement") {
      PageName = this.props.t("UserManagement.ID_USERMANAGEMENT", {
        param: "",
      });
      open = false;
    } else if (Menu === "Dashboard") {
      PageName = this.props.t("Dashboard.IDS_LBL_DASHBOARD", {
        param: "",
      });
      open = false;
    } else if (Menu === "Masters") {
      PageName = this.props.t("Masters.ID_MASTERS", {
        param: "",
      });
      open = false;
    } else if (Menu === "DownloadReport") {
      PageName = this.props.t("Reports.IDS_LBL_SCREENNAME", {
        param: "",
      });
      open = false;
    }

    this.setState({
      MenuGroup: Menu,
      PageName: PageName,
      open: open || true,
      Menuselected: "",
    });
  }

  ChilMenuclick(Menu) {
    this.setState({ ChildMenu: Menu });
  }

  onlogoutSuccess(response) {
    store.dispatch(replacestate(defalutreduxState));
    setTimeout(() => {
      let tenantdomain = $.session.get("tenantdomain");

      if (tenantdomain !== undefined) {
        isMultitenant === 0
          ? this.props.history.push("/")
          : this.props.history.push("/#" + tenantdomain);
        this.props.alert.success(this.props.t("Login.IDS_MSG_LOGOUT"));
      } else {
        this.props.history.push("/")
      }
    }, 100);
  }

  onlogoutFailure(response) { }

  onredirectrights(objrights) {
    // this.setState({
    //     userrightdetails: objrights, sheetcreationvisible: objrights.Sheetcreation,
    //     Protocolcreationvisible: objrights.Protocols, Sheetmapvisible: objrights.Sheetsetting
    // });
    // let sheetRights = ControlRights("IDS_MDL_TEMPLATES", "IDS_SCN_SHEETTEMPLATE");
    // let proRights = ControlRights("IDS_MDL_TEMPLATES", "IDS_SCN_PROTOCOLTEMPLATE");
    let tempmap = ControlRights("IDS_MDL_TEMPLATES", "IDS_SCN_TEMPLATEMAPPING");
    let tempMapRights = ControlRights("IDS_MDL_TEMPLATES");

    this.setState({
      userrightdetails: objrights,
      sheetcreationvisible: SubMenuRightsonScreenViews("IDS_MDL_TEMPLATES", "IDS_SCN_SHEETTEMPLATE"),
      Protocolcreationvisible: SubMenuRightsonScreenViews("IDS_MDL_TEMPLATES", "IDS_SCN_PROTOCOLTEMPLATE"),
      tempmapvisible: tempmap.UserGroupRights.rights,
      Sheetmapvisible: tempMapRights,
    });
  }

  OnNotificationchange(data) {
    if (data !== null && data !== undefined) {
      let notificationorder =
        data.ordercode !== undefined ? data.ordercode : "";
      let isnotificationprocess = data.isprocess ? data.isprocess : false;

      this.setState({
        notificationorderno: notificationorder,
        isnotificationprocess: isnotificationprocess,
      });
    }
  }

  onresetnotification() {
    if (
      this.props.location !== undefined &&
      this.props.location !== null &&
      this.props.location.state !== undefined &&
      this.props.location.state !== null
    ) {
      const history = createHistory;
      if (history.location !== undefined) {
        if (history.location.state && history.location.state.ordercode) {
          let state = { ...history.location.state };
          delete state.ordercode;
          history.replace({ ...history.location, state });
        }
      }
    }

    this.setState({
      notificationorderno: undefined,
      isnotificationprocess: false,
    });
  }

  redirecttohome() {
    this.props.history.push("/Home");
  }

  render() {
    if (!$.session.get("User")) {
      setTimeout(() => {
        let tenantdomain = $.session.get("tenantdomain");
        if (this.props && this.props.history) {
          if (tenantdomain !== undefined) {
            isMultitenant === 0 ? this.props.history.push("/") : this.props.history.push("/#" + tenantdomain);
            // this.props.alert.success(this.props.t("Login.IDS_MSG_LOGOUT"));
          } else {
            this.props.history.push("/")
          }
        }
      }, 100);
      return <div></div>;
    }

    if (!this.state.validurl) {
      const getPath = getModuleRihtsOnOrderModule("IDS_MDL_SETUP");
      console.log(getPath);

      let path = getPath?.path !== undefined ? getPath?.path : "/Home";

      return <Redirect to={path} />;
    }

    return (
      <div id="idElnBody">
        <Suspense fallback={<div></div>}>
          <Menu
            sendData={this.MainMeunClick}
            childmenuclick={this.ChilMenuclick.bind(this)}
            selected={this.state.Menuselected}
            menugroup={this.state.MenuGroup}
            screenname={this.state.screenname}
            redirectrights={this.onredirectrights.bind(this)}
          />
        </Suspense>
        <div id="bodycontent" className="d-flex flex-column">
          <Suspense fallback={<div></div>}>
            <ApplicationHeader
              onlogoutSuccess={this.onlogoutSuccess.bind(this)}
              redirecttohome={this.redirecttohome.bind(this)}
              onlogoutFailure={this.onlogoutFailure.bind(this)}
              PageName={this.state.PageName}
              OnNotificationchange={this.OnNotificationchange.bind(this)}
            />
          </Suspense>
          <AtTabs>
            <Tabs activeKey={"3"} onTabClick={this.ontabclick} moreIcon="...">
              {this.state.sheetcreationvisible ? (
                <TabPane
                  tab={
                    <NavLink
                      to={{ pathname: "/sheetcreation" }}
                      title={this.props.t("Templates.Templatemapping.IDS_LBL_SHEET", {
                        param: "",
                      })}
                    >
                      {this.props.t("Templates.Templatemapping.IDS_LBL_SHEET", {
                        param: "",
                      })}
                    </NavLink>
                  }
                  key="1"
                ></TabPane>
              ) : (
                ""
              )}
              {this.state.Protocolcreationvisible ? (
                <TabPane
                  tab={
                    <NavLink
                      to={{ pathname: "/protocols" }}
                      title={this.props.t("Templates.Templatemapping.IDS_LBL_PROTOCOL", {
                        param: "",
                      })}
                    >
                      {this.props.t("Templates.Templatemapping.IDS_LBL_PROTOCOL", {
                        param: "",
                      })}
                    </NavLink>
                  }
                  key="2"
                ></TabPane>
              ) : (
                ""
              )}
              {this.state.tempmapvisible ? (
                <TabPane
                  tab={this.props.t("Templates.Sheettemplates.IDS_LBL_TEMPLATETEMAPPING", {
                    param: "",
                  })}
                  key="3"
                >
                  <Suspense fallback={<div></div>}>
                    <SheetSettings rights={this.state.userrightdetails} />
                  </Suspense>
                </TabPane>
              ) : (
                ""
              )}
            </Tabs>
          </AtTabs>
        </div>
        <Suspense fallback={<div></div>}>
          <ApplicationFooter
            onlogoutSuccess={this.onlogoutSuccess.bind(this)}
            onlogoutFailure={this.onlogoutFailure.bind(this)}
            onforgot={this.props.onforgot}
          />
        </Suspense>
      </div>
    );
  }
}
export default withAlert()(withTranslation(PProtocols));
